const initialState = {
    error: {
        message: '',
    },
}

// A slice is like a class or folder or url path
// A reducer sets the state

export default function ApiReducer(state = initialState, action) {
    switch (action.type) {
        case 'api/error': {
            return {
                ...state,
                error: action.payload
            }
        }

        case 'api/clearError': {
            return {
                ...state,
                error: { message: '' }
            };
        }

        default:
            return state;
    }
}

// Helper functions for dispatch
export const setError = error => ({
    type: 'api/error',
    payload: error
});

export const clearError = () => ({
    type: 'api/clearError'
});

export const selectError = state => state.api.error